<script>
import { getKitsRelatedToProduct } from "@/api/store/ProductsService.js";

export default {
  data() {
    return {
      kits: []
    };
  },
  props: {
    code: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.loadKitsRelatedToProduct();
  },
  methods: {
    async loadKitsRelatedToProduct() {
      this.kits = await getKitsRelatedToProduct(this.code);
    }
  }
};
</script>
<template>
  <div>
    <ul class="flex flex-row flex-wrap gap-8">
      <li
        v-for="kit in kits"
        :key="kit.nkrCode"
        class="flex flex-col p-4 border border-gray-300 gap-4 justify-center items-center"
      >
        <div class="w-48">
          <img :src="kit.imageRoute" :alt="kit.nkrCode" />
        </div>
        <div>
          <router-link
            :to="{
              name: 'ProductPage',
              params: {
                productCode: kit.kitNkrCode
              }
            }"
            target="_blank"
            class="text-blue-500"
          >
            {{ kit.kitNkrCode }}
          </router-link>
        </div>
        <div>
          {{ kit.name }}
        </div>
      </li>
    </ul>
  </div>
</template>
